import * as React from "react";
import AnnotationMarker from "./AnnotationMarker";
import AnnotationPolygon from "./AnnotationPolygon";
import AnnotationLineString from "./AnnotationLineString";
import AnnotationCircle from "./AnnotationCircle";
import turfArea from "@turf/area";

const Annotations = ({ annotations, map }) => {
  const ordered = React.useMemo(() => {
    return [...annotations].sort((a, b) => {
      return turfArea(b.geometry) - turfArea(a.geometry);
    });
  }, [annotations]);

  return ordered.map((annotation) => {
    if (
      annotation.geometry.type === "LineString" ||
      annotation.geometry.type === "MultiLineString"
    ) {
      return (
        <AnnotationLineString key={annotation.id} annotation={annotation} />
      );
    }

    if (["Polygon", "MultiPolygon"].includes(annotation.geometry.type)) {
      return <AnnotationPolygon key={annotation.id} annotation={annotation} />;
    }

    if (
      annotation.source_id &&
      annotation.geometry.type === "Point" &&
      annotation.layer &&
      annotation.layer.render_properties.circle_radius
    ) {
      return <AnnotationCircle key={annotation.id} annotation={annotation} />;
    }

    return (
      <AnnotationMarker key={annotation.id} annotation={annotation} map={map} />
    );
  });
};

export default Annotations;
